<script>
import Worksheet from "@/views/Front/Sheet/View"
export default {
  name: "SimpleWorksheet",
  extends: Worksheet,
  methods: {
    checkPermission({ sheetId, pri, sheetData, editable, deletable } = {}) {
      return true
    },
    go({ appId = this.curAppId, sheetId = this.curSheetId, viewId } = {}) {
      if (viewId === this.curViewId) return
      this.$router.replace({
        name: "app-template-worksheet",
        params: { appId, sheetId, viewId }
      })
    }
  }
}
</script>
